import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import clsx from 'clsx';
import { Menu as MenuIcon } from '@material-ui/icons';

import {
    makeStyles,
    useMediaQuery,
    BottomNavigation,
    BottomNavigationAction,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Divider
} from '@material-ui/core';

import { MenuEnum } from '../enums';
import IconeMenu from './IconeMenu';

const larguraMenu = 220;
const MenuHOC = withRouter(Menu);

const useStylesMenu = makeStyles(theme => ({
    icon: {
        color: theme.palette.primary[300]
    },
    text: {
        color: theme.palette.primary.contrastText
    },
    active: {
        color: theme.palette.secondary.main
    }
}));

function Menu(
    {
        menu,
        history
    }
) {
    const classes = useStylesMenu();
    const {
        multiEmpresa,
        razaoSocial,
        acessoCarroConectado
    } = JSON.parse(localStorage.getItem('user_data'));
    const listItensMenu = [];

    listItensMenu.push({
        label: MenuEnum.properties[MenuEnum.HOME].label,
        path: MenuEnum.properties[MenuEnum.HOME].path,
        icon: <IconeMenu menu={MenuEnum.HOME} />
    });

    listItensMenu.push({
        label: MenuEnum.properties[MenuEnum.FATURAS].label,
        path: MenuEnum.properties[MenuEnum.FATURAS].path,
        icon: <IconeMenu menu={MenuEnum.FATURAS} />
    });

    listItensMenu.push({
        label: MenuEnum.properties[MenuEnum.MEUS_CARROS].label,
        path: MenuEnum.properties[MenuEnum.MEUS_CARROS].path,
        icon: <IconeMenu menu={MenuEnum.MEUS_CARROS} />
    });

    if (acessoCarroConectado) {
        listItensMenu.push({
            label: MenuEnum.properties[MenuEnum.CARRO_CONECTADO].label,
            path: MenuEnum.properties[MenuEnum.CARRO_CONECTADO].path,
            icon: <IconeMenu menu={MenuEnum.CARRO_CONECTADO} />
        });
    }

    listItensMenu.push({
        label: MenuEnum.properties[MenuEnum.CONTATOS].label,
        path: MenuEnum.properties[MenuEnum.CONTATOS].path,
        icon: <IconeMenu menu={MenuEnum.CONTATOS} />
    });

    listItensMenu.push({
        label: MenuEnum.properties[MenuEnum.LOGOUT].label,
        path: MenuEnum.properties[MenuEnum.LOGOUT].path,
        icon: <IconeMenu menu={MenuEnum.LOGOUT} />
    });

    const handleAlterarEmpresa = () => {
        history.push(MenuEnum.properties[MenuEnum.SELECAO_EMPRESA].path);
    }

    return (
        <>
            <List>
                <ListItem>
                    <Typography component='p'
                        align='center'
                        className={classes.text}>
                        {razaoSocial}
                    </Typography>
                </ListItem>
            </List>
            {
                multiEmpresa &&
                <>
                    <List>
                        <ListItem button
                            onClick={handleAlterarEmpresa}>
                            <ListItemIcon className={classes.icon}>
                                <IconeMenu menu={MenuEnum.SELECAO_EMPRESA} />
                            </ListItemIcon>
                            <ListItemText primary={MenuEnum.properties[MenuEnum.SELECAO_EMPRESA].label}
                                className={classes.text} />
                        </ListItem>
                    </List>
                    <Divider />
                </>
            }
            <List>
                {
                    listItensMenu.map((item, index) => (
                        <ListItem key={index}
                            button
                            component={Link}
                            to={item.path}>
                            <ListItemIcon className={clsx({
                                [classes.icon]: item.path !== MenuEnum.properties[menu].path,
                                [classes.active]: item.path === MenuEnum.properties[menu].path
                            })}>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.label}
                                className={clsx({
                                    [classes.text]: item.path !== MenuEnum.properties[menu].path,
                                    [classes.active]: item.path === MenuEnum.properties[menu].path
                                })} />
                        </ListItem>
                    ))
                }
            </List>
        </>
    );
}

const useStylesDrawerMobile = makeStyles(theme => ({
    list: {
        width: larguraMenu
    },
    menu: {
        backgroundColor: theme.palette.primary.main
    },
    icon: {
        color: theme.palette.primary[300]
    },
    text: {
        color: theme.palette.primary.contrastText
    },
    active: {
        color: theme.palette.secondary.main
    }
}));

function DrawerMobile(
    {
        menu
    }
) {
    const classes = useStylesDrawerMobile();
    const [open, setOpen] = useState(false);

    const toggleDrawer = (openMenu) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(openMenu);
    };

    return (
        <>
            <MenuIcon onClick={toggleDrawer(true)} />
            <Drawer anchor="right"
                PaperProps={{ classes: { root: classes.menu } }}
                open={open}
                onClose={toggleDrawer(false)}>
                <div className={classes.list}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}>
                    <MenuHOC menu={menu} />
                </div>
            </Drawer>
        </>
    );
}

const useStylesLayoutMobile = makeStyles(theme => ({
    divContainer: {
        height: '100%',
        width: '100%',
        marginBottom: '66px'
    },
    divMenu: {
        height: 56,
        width: '100%',
        position: 'fixed',
        left: 0,
        bottom: 0
    },
    navigation: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "12px 12px 0px 0px",
        '& .MuiBottomNavigationAction-root': {
            color: theme.palette.primary[300],
            padding: 1
        },
        '& .MuiBottomNavigationAction-root.Mui-selected': {
            color: theme.palette.secondary.main
        }
    }
}));

function LayoutMobile(
    {
        menu,
        children
    }
) {
    const classes = useStylesLayoutMobile();

    return (
        <>
            <div className={classes.divContainer}>
                {children}
            </div>
            <div className={classes.divMenu}>
                <BottomNavigation value={menu}
                    className={classes.navigation}>
                    <BottomNavigationAction
                        component={Link}
                        to={MenuEnum.properties[MenuEnum.HOME].path}
                        label={MenuEnum.properties[MenuEnum.HOME].label}
                        value={MenuEnum.HOME}
                        icon={<IconeMenu menu={MenuEnum.HOME} />} />
                    <BottomNavigationAction
                        component={Link}
                        to={MenuEnum.properties[MenuEnum.FATURAS].path}
                        label={MenuEnum.properties[MenuEnum.FATURAS].label}
                        value={MenuEnum.FATURAS}
                        icon={<IconeMenu menu={MenuEnum.FATURAS} />} />
                    <BottomNavigationAction
                        component={Link}
                        to={MenuEnum.properties[MenuEnum.MEUS_CARROS].path}
                        label={MenuEnum.properties[MenuEnum.MEUS_CARROS].label}
                        value={MenuEnum.MEUS_CARROS}
                        icon={<IconeMenu menu={MenuEnum.MEUS_CARROS} />} />
                    <BottomNavigationAction
                        label='Menu'
                        value={null}
                        icon={<DrawerMobile menu={menu} />} />
                </BottomNavigation>
            </div>
        </>
    );
}

const useStylesLayoutWeb = makeStyles(theme => ({
    divMenu: {
        height: '100%',
        width: larguraMenu,
        position: 'fixed',
        left: 0,
        top: 0
    },
    divMain: {
        marginLeft: larguraMenu,
        height: '100%',
        padding: '0px 10px'
    },
    menu: {
        height: 'inherit',
        backgroundColor: theme.palette.primary.main
    }
}));

function LayoutWeb(
    {
        menu,
        children
    }
) {
    const classes = useStylesLayoutWeb();

    return (
        <>
            <div className={classes.divMenu}>
                <div className={classes.menu} >
                    <MenuHOC menu={menu} />
                </div>
            </div>
            <div className={classes.divMain}>
                {children}
            </div>
        </>
    );
}

function Layout(
    {
        match,
        history,
        component: Component,
        ...props
    }
) {
    let mobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const [menu, setMenu] = useState(MenuEnum.HOME);

    useEffect(() => {
        const obterValorMenu = () => {
            const { url } = match;

            if (url.indexOf(MenuEnum.properties[MenuEnum.FATURAS].path) > -1)
                return MenuEnum.FATURAS;

            if (url.indexOf(MenuEnum.properties[MenuEnum.MEUS_CARROS].path) > -1)
                return MenuEnum.MEUS_CARROS;

            if (url.indexOf(MenuEnum.properties[MenuEnum.CARRO_CONECTADO].path) > -1)
                return MenuEnum.CARRO_CONECTADO;

            if (url.indexOf(MenuEnum.properties[MenuEnum.CONTATOS].path) > -1)
                return MenuEnum.CONTATOS;

            if (url.indexOf(MenuEnum.properties[MenuEnum.LOGOUT].path) > -1)
                return MenuEnum.LOGOUT;

            return MenuEnum.HOME;
        }

        setMenu(obterValorMenu());
    }, [match, setMenu]);

    return mobile ?
        <LayoutMobile menu={menu}>
            <Component {...props} />
        </LayoutMobile> :
        <LayoutWeb menu={menu}>
            <Component {...props} />
        </LayoutWeb>
}

export default withRouter(Layout);